document.addEventListener('DOMContentLoaded', () => {
  function reloadVendorScript() {
    return new Promise((resolve, reject) => {
      // Busca el script actual de vendor-scripts-v2.js sin importar el /t/XXX ni el v=
      const current = [...document.querySelectorAll('script[src*="vendor-scripts-v2.js"]')][0];

      if (!current) {
        console.warn('No se encontró vendor-scripts-v2.js en el DOM');
        return resolve();
      }

      // limpiamos el query param ?v=xxxx o cualquier otro
      let cleanSrc = current.src.split('?')[0];

      // 🧹 Eliminamos todos los scripts previos de vendor-scripts-v2.js
      document.querySelectorAll('script[src*="vendor-scripts-v2.js"]').forEach(s => s.remove());

      // ♻️ Creamos e insertamos uno nuevo con nuestro propio cache-buster
      const script = document.createElement('script');
      script.src = `${cleanSrc}?cb=${Date.now()}`;  // fuerza recarga
      script.defer = true;

      script.onload = () => {
        console.log('[vendor-scripts-v2.js] recargado correctamente');
        resolve();
      };

      script.onerror = (e) => {
        console.error('[vendor-scripts-v2.js] error al recargar:', e);
        reject(e);
      };

      document.head.appendChild(script);
    });
  }

  function initInjectedPdp(root) {
    if (!root) return;

    // Forzar rama "página" para que ejecute initProductSlider()
    root.dataset.modal = 'false';
    root.dataset.history = 'false';

    // Limpia instancia previa si reabres
    const key = `product:${root.dataset.sectionId || root.dataset.productId}`;
    window.__productInstances ??= {};
    window.__productInstances[key]?.onUnload?.();

    const instance = new theme.Product(root);
    window.__productInstances[key] = instance;
  }
  
  // Fetch and display product content when quick view triggers are clicked
  async function handleQuickViewClick(event, variantId = false) {
    const trigger = event.target.closest(".quick-view-trigger") ? event.target.closest(".quick-view-trigger") : event.target.closest(".sticky-quick-view__dropdown-item");
    if (!trigger) return;
    event.preventDefault();

    const handle = trigger.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}${variantId ? `?variant=${variantId}` : ''}`);
      const htmlString = await res.text();

      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const main = doc.getElementById('MainContent');
      if (!main) throw new Error('No se encontró #MainContent en la respuesta');

      const contentContainer = document.getElementById('product-modal-content');
      contentContainer.innerHTML = '';

      const mainSection = main.querySelector('.main-product-section');
      const productFullWidthSection = main.querySelector('.product-full-width');
      const stickyQuickViewSection = doc.querySelector('.sticky-quick-view-section');

      if (mainSection) contentContainer.appendChild(mainSection.cloneNode(true));
      if (productFullWidthSection) {
        const lstTabs = productFullWidthSection.querySelectorAll('.product-block--tab');
        const firstTab = lstTabs[0].querySelector('.collapsible-trigger');
        const firstContent = lstTabs[0].querySelector('.collapsible-content');
        firstTab?.setAttribute('aria-expanded', 'true');
        firstTab?.classList.add('is-open');
        firstContent?.classList.add('is-open');
        contentContainer.appendChild(productFullWidthSection.cloneNode(true));
      }
      if (stickyQuickViewSection) contentContainer.appendChild(stickyQuickViewSection.cloneNode(true));

      await reloadVendorScript();

      // ✅ AHORA sí, toma el root desde el modal inyectado
      const productRoot = contentContainer.querySelector('.product-section[data-product-id]');
      if (!productRoot) {
        console.warn('No se encontró .product-section[data-product-id] dentro del modal');
        return;
      }

      await initInjectedPdp(productRoot);

      if (window.theme?.collapsibles?.init) {
        theme.collapsibles.init(contentContainer);
      }

      if (variantId === false) openModal();
    } catch (err) {
      console.error('Error loading product modal:', err);
    }
  }

  function openModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.remove("hidden");
    modal.setAttribute("aria-hidden", "false");
    // optionally lock body scroll
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    // clean up content for next open (optional)
    document.getElementById("product-modal-content").innerHTML = "";
  }

  // Close modal on overlay or close button click
  document.addEventListener("click", function (event) {
    if (event.target.matches(".quick-view-trigger")) {
      handleQuickViewClick(event);
    } else if (
      event.target.closest(".product-modal__close") ||
      event.target.matches(".product-modal__overlay")
    ) {
      closeModal();
    }
  });

  // Optional: close modal on Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const modal = document.getElementById("product-modal");
      if (!modal.classList.contains("hidden")) closeModal();
    }
  });

  let variantData = [];
  let selectedOptions = {};

  // Helper to find the sticky quick view element associated with a clicked element
  function findStickyBar(el) {
    return el.closest('.sticky-quick-view');
  }

  // Update variant and UI for a given sticky bar
  function updateVariant(stickyBar, state = false) {
    if (!stickyBar) return;
    let addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
    let priceContainer = addButton && addButton.querySelector('.sticky-quick-view__price');
    if (!addButton || !priceContainer) return;
    variantData = stickyBar.dataset.variantData ? JSON.parse(stickyBar.dataset.variantData) : [];

    // Initialise with the first variant’s options if available
    if (state && variantData.length > 0) {
      variantData[0].options.forEach(function (opt, idx) {
        selectedOptions[idx] = opt;
      });
    } else if (!state && variantData.length > 0) {
      let lstLabels = stickyBar.querySelectorAll('.sticky-quick-view__label');
      lstLabels.forEach((label, idx) => {
        selectedOptions[idx] = label.textContent.trim();
      });
    }
    
    let match = variantData.find(function (variant) {
      return variant.options.every(function (option, idx) {
        return selectedOptions[idx] === option;
      });
    });

    if (match) {
      addButton.dataset.variantId = match.id;
      priceContainer.textContent = '– ' + match.price;
      addButton.disabled = !match.available;
    } else {
      addButton.dataset.variantId = '';
      priceContainer.textContent = '';
      addButton.disabled = true;
    }
  }

  // Delegated click handling for dropdown toggles and items
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('.sticky-quick-view__dropdown-toggle')) {
      let dropdown = event.target.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(event.target);
      if (!dropdown || !stickyBar) return;
      let isOpen = dropdown.classList.contains('is-open');
      // Close any other open dropdowns within this sticky bar
      stickyBar.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is-open');
          let otherToggle = otherDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      // Toggle the clicked dropdown
      dropdown.classList.toggle('is-open', !isOpen);
      event.target.closest('.sticky-quick-view__dropdown-toggle').setAttribute('aria-expanded', String(!isOpen));
      event.stopPropagation();
      return;
    } else if (event.target && event.target.closest('.sticky-quick-view__dropdown-item')) {
      let item = event.target.closest('.sticky-quick-view__dropdown-item');
      let value = item.getAttribute('data-value');
      let index = parseInt(item.getAttribute('data-index'), 10);
      let dropdown = item.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(item);
      if (!dropdown || !stickyBar) return;
      // Update selected option state
      selectedOptions[index] = value;
      // Update the toggle’s label and swatch
      let toggleBtn = dropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (toggleBtn) {
        let labelSpan = toggleBtn.querySelector('.sticky-quick-view__label');
        if (labelSpan) labelSpan.textContent = value;
        let swatchSpan = toggleBtn.querySelector('.sticky-quick-view__color-swatch');
        if (swatchSpan && item.dataset.color) {
          swatchSpan.style.backgroundColor = item.dataset.color;
        }
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      // Close the dropdown
      dropdown.classList.remove('is-open');
      // Update variant and price
      updateVariant(stickyBar);
      const addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
      if (addButton) handleQuickViewClick(event, addButton.dataset.variantId);
    } else if (event.target && event.target.closest('.sticky-quick-view__add-to-cart')) {
      let addBtn = event.target.closest('.sticky-quick-view__add-to-cart');
      if (addBtn) {
        let variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('shopify:custom:add-to-cart', { userId: 123, action: "clicked" }));
            closeModal();
            addBtn.disabled = false;
          })
          .catch(function () {
            addBtn.disabled = false;
          });
        event.stopPropagation();
      }
    }
    // Click outside: close all open dropdowns
    document.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (openDropdown) {
      openDropdown.classList.remove('is-open');
      let t = openDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Initialise variant display for any existing sticky bars on load
  document.querySelectorAll('.sticky-quick-view').forEach(function (bar) {
    updateVariant(bar, true);
  });
});